module.exports = __webpack_public_path__ + "static/img/spot2419-1.8dda9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spot2419-1.png
// module id = MOxF
// module chunks = 0